module.exports = __webpack_public_path__ + "static/img/ndvi_6.39359155.jpg";